/**
 * Typed access to Vite environment variables.
 *
 * Import from here instead of touching `import.meta.env` all over the app —
 * one place to change when a variable is renamed, and no silent `undefined`.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  appName: import.meta.env.VITE_APP_NAME ?? 'Institute Management System',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
